import api from "./api";

export interface IFichaTecnica {
    nombre: string;
    enlace: string;
}

export interface IFichasTecnicasResponse {
    datos: IFichaTecnica[];
}

/**
 * Obtiene desde backend la lista de fichas tecnicas de productos con sus enlaces.
 *
 * Disponible para cualquier usuario autenticado: se muestra como una seccion
 * desplegable dentro de la vista Sobre Nosotros.
 * Los archivos viven en Google Drive, aca solo se manejan nombre y enlace.
 */
export const fetchFichasTecnicas = async (): Promise<IFichaTecnica[]> => {
    try {
        const response = await api.get<IFichasTecnicasResponse>("/fichas-tecnicas");
        return response.data.datos; // Extraemos solo la lista de fichas
    } catch (error) {
        console.error("Error al obtener las fichas tecnicas:", error);
        throw error;
    }
};
